import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { ChildId } from 'types';
import { guardianAddEditErrorParser } from 'utils/errorHandlers/guardian/guardianAddEditErrorParser';
import { childrenTexts } from 'consts/text/index';
import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';

type UseParentGuardianMutateProps = {
    childId: ChildId;
};

export const useParentGuardianMutate = ({ childId }: UseParentGuardianMutateProps) => {
    const { displayError, displaySuccess } = useSimpleNotification();
    const invalidateQueryKeys = [['CHILD', childId]];
    const queryKey = ['CHILD', childId];
    const { mutate: addGuardian, isLoading: isAddGuardianLoading } = useAppMutation(
        ParentHTTPService.children.guardian.addGuardian,
        {
            onSuccess: () => displaySuccess(childrenTexts.successfullyAddGuardianMessage),
            onError: (error) =>
                displayError(
                    guardianAddEditErrorParser(error, childrenTexts.addGuardianErrorMessage),
                ),
            key: queryKey,
            invalidateQueryKeys,
        },
    );
    const { mutate: deleteGuardian, isLoading: isDeleteGuardianLoading } = useAppMutation(
        ParentHTTPService.children.guardian.deleteGuardian,
        {
            onSuccess: () => displaySuccess(childrenTexts.successfullyDeleteGuardianMessage),
            onError: () => displayError(childrenTexts.deleteGuardianErrorMessage),
            key: queryKey,
            invalidateQueryKeys,
        },
    );
    const { mutate: updateGuardian, isLoading: isUpdateGuardianLoading } = useAppMutation(
        ParentHTTPService.children.guardian.updateGuardian,
        {
            onSuccess: () => displaySuccess(childrenTexts.successfullyUpdateGuardianMessage),
            onError: (error) =>
                displayError(
                    guardianAddEditErrorParser(error, childrenTexts.updateGuardianErrorMessage),
                ),
            key: queryKey,
            invalidateQueryKeys,
        },
    );

    return {
        addGuardian,
        isAddGuardianLoading,
        deleteGuardian,
        isDeleteGuardianLoading,
        updateGuardian,
        isUpdateGuardianLoading,
        isGuardianMutating:
            isAddGuardianLoading || isDeleteGuardianLoading || isUpdateGuardianLoading,
    };
};
